//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconFormTextLong(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M21 5H12V7H21V5Z" fill="currentColor" /><path d="M21 11H12V13H21V11Z" fill="currentColor" /><path d="M21 17H12V19H21V17Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M6.5 9.9375L9 9.9375V7.9375H2V9.9375L4.5 9.9375V17H6.5V9.9375Z" fill="currentColor" /></svg>;
}
export default IconFormTextLong;